import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const AuthGuard = async ():Promise<boolean> => {
  const auth = inject(AuthService)
  return auth.checkSessionByToken().then(a => {
    return true;
  }).catch(e => {
    console.log(e)
    return false;
  });
}